import React, {FC, ReactNode} from 'react';
import styled, {css} from 'styled-components';

import {boxShadow} from '../../../../../../../libs/shared/ui/src/theme/themeStyleHelpers';

/*
 * Style.
 */

export const StyledCellHoverIconsWrapper = styled.div<{$isCompact: boolean}>`
  display: none;

  padding: 2px;
  z-index: 2;
  border-radius: 8px;
  background: ${(p) => p.theme.greys.shade10};
  ${(p) => boxShadow(p.theme, `0px 0px 8px rgba(0, 0, 0, 0.1)`)};
  ${(p) => addLayoutStyles(p.$isCompact)}
`;

function addLayoutStyles(isCompact: boolean) {
  if (!isCompact) {
    return css`
      grid-row-start: top-right;
      grid-column-start: top-right;
      grid-row-end: top-right;
      grid-column-end: bottom-right;
      justify-self: center;
      align-self: start;
      flex-direction: column;
      max-width: 30px;
      margin-top: -5px; // Accounts for padding on the icon
    `;
  }

  return css`
    position: absolute;
    right: 3px;
    top: 3px;
    max-width: 58px;
    flex-direction: row-reverse;
  `;
}

/*
 * Component.
 */

export const CellsHoverIconsBase: FC<{
  isCompact: boolean | undefined;
  children: ReactNode;
}> = (props) => (
  <StyledCellHoverIconsWrapper $isCompact={Boolean(props.isCompact)}>
    {props.children}
  </StyledCellHoverIconsWrapper>
);
